import THEME from "constants/themes";
import { EMAIL_OPT_IN } from "constants/widgetBuilder";
import { WidgetDetailTypes } from "models/Widget";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { getReplacedFieldValuesOptIn } from "services/widgetBuilder";
import { StyledText } from "styled-components/Common/CommonStyled";
import {
	StyledSectionTitle,
	StyledWidgetSectionWrapper,
} from "styled-components/DynamicWidget/DynamicWidgetStyled";
import { StyledLink } from "styled-components/WidgetBuilder/WidgetBuilderStyled";
import WidgetTerms from "../WidgetTerms";
import { TermTypes } from "models/DynamicWidget";

type WidgetTermsSectionProps = {
	widgetDetails: WidgetDetailTypes;
	termList: TermTypes[];
	setTermList: (terms: TermTypes[]) => void;
	isSubmitting: boolean;
	setIsSubmitting: (value: boolean) => void;
};

const WidgetTermsSection = (props: WidgetTermsSectionProps) => {
	const { t } = useTranslation();
	const { widgetDetails, termList, setTermList, isSubmitting, setIsSubmitting } = props;
	const { clientDetail = {} } = useSelector((state: any) => state.widgets);
	const { brandName = "" } = clientDetail || {};
	const { metadata = "" } = widgetDetails || {};

	const { colors, body } = metadata || {};
	const { emailOptIn = {}, moreInfoTerms: { termsSectionHeader = "" } = {} } = body || {};
	const { highlight } = colors || {};
	const { name: emailOptInType = "", fieldValues } = emailOptIn || {};
	const replacedFieldValuesOptIn = getReplacedFieldValuesOptIn(fieldValues, brandName);

	const renderEmailOptText = () => {
		return (
			emailOptInType === EMAIL_OPT_IN.OPT_IN_SUBMISSION.name && (
				<StyledText
					style={{
						whiteSpace: "normal",
					}}
					margin="16px 0 0 0"
					fontSize="14px"
					align="unset"
					color={THEME.colors.darkBlue1}>
					{replacedFieldValuesOptIn?.agreementMessage}
					<StyledLink
						href={replacedFieldValuesOptIn?.hyperlinkUrl}
						fontSize="14px"
						color={highlight}
						target="_blank">
						{replacedFieldValuesOptIn?.hyperlinkText}
					</StyledLink>
				</StyledText>
			)
		);
	};

	return (
		<StyledWidgetSectionWrapper>
			<StyledSectionTitle>
				{termsSectionHeader || t("widget_builder.agreements")}
			</StyledSectionTitle>
			<WidgetTerms
				termList={termList}
				setTermList={setTermList}
				isSubmitting={isSubmitting}
				setIsSubmitting={setIsSubmitting}
			/>
			{renderEmailOptText()}
		</StyledWidgetSectionWrapper>
	);
};

export default WidgetTermsSection;
